import React from 'react';
import { withTranslation } from 'react-i18next';
import { BsCheck2 } from 'react-icons/bs';
import './CalculPage.scss';

class CalculPage extends React.Component<any, any> {

    render() {
        return (
            <div className="CalculPage">
                <div className='title'>
                    <h1>{this.props.t('BudgetBikeTitle1')}</h1> 
                    <span className='text-important'>{this.props.t('BudgetBikeTitle2')}</span>
                    <h1>{this.props.t('BudgetBikeTitle3')}</h1>
                </div>
                <div className='baseSalary'>
                    <p>{this.props.t('BudgetBikeBaseSalaryDescription')}</p>
                    <div className='sameLine'>
                        <input
                            type='number'
                            className='budgetInput'
                            defaultValue={this.props.salaryInput}
                            onChange={(e) => this.props.updateSalaryInput(parseInt(e.target.value))}
                        />
                        <p>{this.props.t('BudgetBikeBaseSalaryJoin')}</p>
                        <select className='selectTimeInput' onChange={(e) => this.props.updateUnitInput(e.target.value)}>
                            <option 
                                value='hour'
                                selected={this.props.unitInput === 'hour' ? true : false}
                            >{this.props.t('BudgetBikeBaseSalaryOption1')}</option>
                            <option 
                                value='month'
                                selected={this.props.unitInput === 'month' ? true : false}
                            >{this.props.t('BudgetBikeBaseSalaryOption2')}</option>
                        </select>
                    </div>
                </div>
                <div className='regime'>
                    <p>{this.props.t('BudgetBikeRegimeDescription')}</p>
                    <div className='sameLine'>
                        <input 
                            type='number' 
                            className='hourInput' 
                            defaultValue={this.props.hourWorkInput}
                            onChange={(e) => this.props.updateHourInput(parseInt(e.target.value))}
                        />
                        <p>{this.props.t('BudgetBikeRegimeUnit')}</p>
                    </div>
                </div>
                <div>
                    <p>{this.props.t('BudgetBikeSalaryResult')} {this.props.monthSalary}</p>
                </div>
                <div>
                    <div className='btnCalcul' onClick={this.props.displayRightPage}>
                        <p className='textBtn'>{this.props.t('BudgetBikeCalculBtn')}</p>
                        <BsCheck2 className='iconBtn'/>
                    </div>
                </div>
                <div className='logo-section'>
                    <img className='logo' src={require('../../../assets/image/carrefourLogo.png')} alt="logo" />
                </div>
            </div>
        );
    }
}

export default withTranslation()(CalculPage);
